module.exports = __webpack_public_path__ + "assets/Minus.819a716389596919163bca7dc2ff1f92.svg";